import React from "react";
import { Box, Grid, MenuItem } from "@mui/material";
import { Form, Formik } from "formik";
import CustomTextField from "../../../components/Forms/CustomTextField";
import CustomSubmitButton from "../../../components/Forms/CustomSubmitButton";
import { Save } from "@mui/icons-material";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import useRTK from "../../../hooks/useRTK";
import CustomTextArea from "../../../components/Forms/CustomTextArea";
import CustomSelectInput from "../../../components/Forms/CustomSelectInput";
import { useUpdateSubscriptionPackageMutation } from "../../../api/subscriptionPackages/subscriptionPackagesAPI";
import { setSubscriptionPackages } from "../../../states/features/subscriptionPackages/subscriptionPackagesSlice";
import { numFormater } from "../../../helpers/numFormater";

const updatePackageValidationSchema = Yup.object({
    name: Yup.string().required(),
    type: Yup.string().required(),
    price: Yup.string().required(),
    discount_per: Yup.string().nullable(),
    duration: Yup.string().required(),
    description: Yup.string().max(100).nullable(),
});

const UpdateSubscriptionPackage = ({
    handleDialogClose,
    subscriptionPackage,
}) => {
    // ############# CONST ##################
    const RTK = useRTK();
    const dispatch = useDispatch();
    const getDays = () => {
        let durations = [];
        for (let index = 1; index < 31; index++) {
            durations.push(index);
        }
        return durations;
    };
    const getPercentages = () => {
        let percentages = [];
        for (let index = 0; index <= 100; index++) {
            percentages.push(index);
        }
        return percentages;
    };
    const percentages = getPercentages();
    const durations = getDays();
    const packageTypes = [
        {
            id: 1,
            type: "Talent tap",
        },
        {
            id: 2,
            type: "Market mingle",
        },
        {
            id: 3,
            type: "Promo connect",
        },
    ];

    // ############# RTK ##################
    const [
        updatePackage,
        { isLoading, isSuccess: addSuccess, isError, error, data: addData },
    ] = useUpdateSubscriptionPackageMutation();

    // ############# useEffect ##################
    const rtkActions = (data) => {
        handleDialogClose();
        dispatch(setSubscriptionPackages(data));
    };
    RTK.useRTKResponse(addSuccess, isError, error, addData, rtkActions);

    return (
        <>
            <Box>
                <Formik
                    initialValues={{
                        package_id: subscriptionPackage.id,
                        name: subscriptionPackage
                            ? subscriptionPackage.name
                            : "",
                        type: subscriptionPackage
                            ? subscriptionPackage.type
                            : "",
                        price: subscriptionPackage
                            ? subscriptionPackage.price +
                              subscriptionPackage?.discount_amount
                            : "",
                        discount_per: subscriptionPackage
                            ? subscriptionPackage.discount_per
                            : "",
                        duration: subscriptionPackage
                            ? subscriptionPackage.duration
                            : "",
                        description: subscriptionPackage
                            ? subscriptionPackage.description
                            : "",
                    }}
                    validationSchema={updatePackageValidationSchema}
                    onSubmit={(payload) => {
                        updatePackage(payload);
                    }}
                >
                    {(formik) => (
                        <Form>
                            <Grid
                                container
                                justifyContent={"center"}
                                columnSpacing={2}
                            >
                                <Grid item sm={6} xs={6}>
                                    <CustomTextField
                                        name="name"
                                        type={"text"}
                                        label={"Package name"}
                                    />
                                </Grid>
                                <Grid item sm={6} xs={6}>
                                    <CustomSelectInput
                                        type="text"
                                        name="type"
                                        label="Package type"
                                        formik={formik}
                                        color="primary"
                                    >
                                        {packageTypes.map((type) => (
                                            <MenuItem
                                                value={type.type}
                                                key={type.id}
                                            >
                                                {type.type}
                                            </MenuItem>
                                        ))}
                                    </CustomSelectInput>
                                </Grid>
                                <Grid item sm={6} xs={6}>
                                    <CustomTextField
                                        name="price"
                                        type={"text"}
                                        label={"Package price"}
                                        comment={`discount ${numFormater(
                                            (formik.getFieldMeta("price")
                                                .value *
                                                formik.getFieldMeta(
                                                    "discount_per"
                                                ).value) /
                                                100
                                        )} TZS`}
                                    />
                                </Grid>
                                <Grid item sm={3} xs={3}>
                                    <CustomSelectInput
                                        type="text"
                                        name="discount_per"
                                        label="Discount (%)"
                                        formik={formik}
                                        color="primary"
                                    >
                                        {percentages.map(
                                            (percentage, index) => (
                                                <MenuItem
                                                    value={percentage}
                                                    key={index}
                                                >
                                                    {percentage + ` %`}
                                                </MenuItem>
                                            )
                                        )}
                                    </CustomSelectInput>
                                </Grid>
                                <Grid item sm={3} xs={3}>
                                    <CustomSelectInput
                                        type="text"
                                        name="duration"
                                        label="Package duration"
                                        formik={formik}
                                        color="primary"
                                    >
                                        {durations.map((duration, index) => (
                                            <MenuItem
                                                value={duration}
                                                key={index}
                                            >
                                                {duration + ` days`}
                                            </MenuItem>
                                        ))}
                                    </CustomSelectInput>
                                </Grid>
                                <Grid item sm={12} xs={12}>
                                    <CustomTextArea
                                        name="description"
                                        type={"text"}
                                        label={"Package description"}
                                        rows={3}
                                        maxChar={100}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    sm={12}
                                    sx={{
                                        mt: 2,
                                    }}
                                >
                                    <CustomSubmitButton
                                        loading={isLoading}
                                        startIcon={<Save />}
                                        onClick={formik.handleSubmit}
                                        btnColor={"info"}
                                        sx={{
                                            py: 2,
                                        }}
                                    >
                                        Update package
                                    </CustomSubmitButton>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
        </>
    );
};

export default UpdateSubscriptionPackage;
